<!-- Header -->
<div class="header right">
  <div class="container">
    <div class="header-logo">
      <h3 class="font-family-syne letter-spacing-1">
        <a routerLink="/">Komo</a>
      </h3>
    </div>

    <!-- Menu -->
    <div class="header-menu" [ngClass]="{ 'show': isMenuOpen }">
      <ul class="nav">
        <!-- Dropdown Item -->
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(0)">Home</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 0 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/">Startup Agency</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-two">Design Agency</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-three">Corporate Business</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-four">Consulting</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-five">Digital Agency</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-six">SEO Agency</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 0 }" (click)="toggleDropdown(0)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(1)">Pages</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 1 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/about-us">About Us</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/our-team">Our Team</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/team-details">Team Details</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/testimonials">Testimonials</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/pricing-table">Pricing Table</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/404-page">404 Error Page</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/coming-soon">Coming Soon</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 1 }" (click)="toggleDropdown(1)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(2)">Services</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 2 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/services">Services</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/service-two">Service Two</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/service-three">Service Three</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/service-four">Service Four</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 2 }" (click)="toggleDropdown(2)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(3)">Portfolio</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 3 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-two-column">Portfolio Two Columns</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-three-column">Portfolio Three Columns</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-four-column">Portfolio Four Columns</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-detail">Portfolio Details</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 3 }" (click)="toggleDropdown(3)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(4)">Blogs</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 4 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/blog-grid">Blog Grid</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/blog-standard">Blog Standard</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 4 }" (click)="toggleDropdown(4)"></a>
        </li>

        <li class="nav-item" (click)="closeMenu()">
          <a class="nav-link" routerLink="/contact">Contact Us</a>
        </li>
      </ul>
    </div>

    <!-- Social Icons -->
    <div class="header-menu-extra">
      <a class="button button-sm button-rounded button-gradient-5 align-middle" routerLink="/">Buy Now</a>
    </div>

    <!-- Menu Toggle -->
    <button class="header-toggle" [class.toggle-close]="isMenuOpen" (click)="toggleMenu()">
      <span></span>
    </button>
  </div>
</div>
<!-- end Header -->

<!-- Hero section -->
<div class="section-2xl">
  <div class="container">
    <div class="row g-4">
      <div class="col-12 col-lg-10 col-xl-9">
        <h1 class="display-4 fw-bold m-0 line-height-130 font-family-syne"><span class="text-gradient-5">Delivering Future Ready IT Solutions to Drive Efficiency, Security, and Growth for Your Business.</span></h1>
      </div>
    </div><!-- end row -->
  </div><!-- end container -->
</div>
<!-- end Hero section -->
 
<!-- Portfolio section -->
<div class="section pt-0">
  <div class="container">
    <div class="row g-4 portfolio-grid hover-style-3 border-radius">
      <div class="col-12 col-md-6 portfolio-item" *ngFor="let work of portfolioWorks">
      <div class="portfolio-box">
        <div class="portfolio-img">
        <img [src]="work.img" [alt]="work.title">
        </div>
        <a [routerLink]="work.link"></a>
        <div class="portfolio-title">
        <div class="portfolio-title-item">
          <h5 class="font-family-syne fw-normal">{{ work.title }}</h5>
        </div>
        <div class="portfolio-title-item">
          <span>{{ work.category }}</span>
        </div>
        </div>
      </div>
      </div>
    </div><!-- end portfolio-grid -->
  </div><!-- end container -->
</div>
<!-- end Portfolio section -->

<div class="section-sm pt-0">
  <div class="container">
    <div class="row g-4">
      <div *ngFor="let fact of funFacts" class="col-12 col-sm-6 col-md-3">
        <h2 class="fw-bold counter">{{fact.displayedNumber | number:'1.0-0'}}</h2>
        <h6 class="fw-medium font-family-syne">{{fact.desc}}</h6>
      </div>
    </div>
  </div>
</div>

<!-- About section -->
<div class="section-lg bg-gradient-5">
  <div class="container">
    <div class="row g-5 align-items-center">
      <div class="col-12 col-lg-6">
        <h3 class="fw-light mb-3 font-family-syne">Trusted IT Experts Committed to Securing, Optimizing, and Scaling Your Digital Infrastructure.</h3>
        <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p>
      </div>
      <div class="col-12 col-lg-6">
        <!-- Progress bar box -->
        <div *ngFor="let skill of skills" class="progress-box mt-4">
          <h6 class="fw-normal font-family-syne">{{ skill.name }}</h6>
          <div class="animated-progress">
            <div [style.width]="skill.level + '%'" [attr.aria-valuenow]="skill.level" aria-valuemin="0" aria-valuemax="100"><span>{{ skill.level }}</span></div>
          </div>
        </div>
      </div>
    </div><!-- end row -->
  </div><!-- end container -->
</div>
<!-- end About section -->

<div class="container-fluid p-0 bg-gray-lighter">
  <div class="row g-0 align-items-center">
    <div class="col-12 col-lg-6">
      <img src="assets/images/about/about-img-2.jpg" alt="about-2">
    </div>
    <div class="col-12 col-lg-6">
      <div class="p-5 text-center">
        <h6 class="display-3 fw-normal font-family-syne">Experts Who Speak Tech, So You Don't Have To</h6>
        <a class="button-circle button-circle-xl button-circle-gradient-5 button-circle-ripple icon-lg mt-3 lightbox-media-link" (click)="openPopup()"><i class="bi bi-play"></i></a>
      </div>
    </div>
  </div><!-- end row -->
</div><!-- end container-fluid -->

<!-- Video Popup -->
<div class="video-popup" *ngIf="isOpen">
    <div class="popup-inner">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/_r0vlyp33pw?si=6QvabQvNDeYzXpw9" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <button (click)="closePopup()" type="button" class="close-btn">
            <i class='bi bi-x'></i>
        </button>
    </div>
</div>

<!-- Services section -->
<div class="section-lg">
  <div class="container">
    <div class="mb-5">
      <div class="row g-4">
        <div class="col-12 col-md-10 col-lg-8">
          <h6 class="font-small fw-medium font-family-syne letter-spacing-1"><span class="text-gradient-5">Services</span></h6>
          <h2 class="font-family-syne">What We Do</h2>
        </div>
      </div>
    </div>
    <div class="row icon-5xl g-4">
      <div class="col-12 col-md-4" *ngFor="let service of services">
      <i [class]="'bi ' + service.icon + ' text-gradient-5'"></i>
      <h4 class="fw-normal mt-2 font-family-syne">{{ service.title }}</h4>
      <p>{{ service.description }}</p>
      </div>
    </div><!-- end row -->
  </div><!-- end container -->
</div>
<!-- end Services section -->

<!-- Clients section -->
<div class="section bg-gray-lighter">
  <div class="container">
    <owl-carousel-o [options]="brandCarouselOptions" class="client-carousel">
        <ng-template carouselSlide *ngFor="let brand of brands">
            <div class="client-box">
                <a routerLink="/">
                    <img [src]="brand.image" [alt]="brand.alt">
                </a>
            </div>
        </ng-template>
    </owl-carousel-o><!-- end owl-carousel -->
  </div><!-- end container -->
</div>
<!-- end Clients section -->

<!-- Blog section -->
<div class="section">
  <div class="container">
    <div class="blog-card-wrapper bg-image" *ngFor="let blog of blogs; let i = index" [ngClass]="{ 'mt-4': i !== 0 }" [style.backgroundImage]="'url(' + blog.image + ')'">
        <div class="blog-card">
            <div class="blog-card-date">
                <h1 class="display-4 fw-medium text-color-theme m-0">{{ blog.date }}</h1>
                <h6 class="font-small uppercase letter-spacing-1">{{ blog.month }}</h6>
            </div>
            <h4 class="fw-medium mt-2">
                <a class="text-link-1" [routerLink]="blog.link">{{ blog.title }}</a>
            </h4>
            <p>{{ blog.description }}</p>
            <a class="button-text-3 d-inline-block mt-4" [routerLink]="blog.link">Read more</a>
        </div>
    </div>
  </div><!-- end container -->
</div>
<!-- end Blog section -->

<app-footer></app-footer>